import { FC, memo } from 'react';

import { Box, Heading } from '@chakra-ui/react';
import isEqual from 'lodash/fp/isEqual';
import {
  Card,
  DonorMessage,
  DonorMessageProps,
  PaginationList,
} from '../../../components';

export interface DonorMessagesProps {
  donorMessages: DonorMessageProps[];
  isLoading?: boolean;
}

export const DonorMessages: FC<DonorMessagesProps> = memo(
  ({ donorMessages, isLoading }: DonorMessagesProps) => (
    <Card>
      <Heading size="md" color="brand.primary.swatch1">
        Donor Messages
      </Heading>
      <Box pt={4}>
        <PaginationList
          isLoading={isLoading}
          listItems={donorMessages}
          listKey="giftId"
          trackingLabel="donorMessages"
        >
          <DonorMessage />
        </PaginationList>
      </Box>
    </Card>
  ),
  isEqual
);
